import {Grid, styled} from "@mui/material";

const BLOGS_PREFIX = "Blogs";

export const blogsClasses = {
    root: `${BLOGS_PREFIX}-root`,
};

export const StyledBlogs = styled(Grid)(({ theme }) => ({
    [`&.${blogsClasses.root}`]: {},
}));

